import './Header.css';
import {ReactComponent as Wave} from './wave.svg';

function Header(){
    return (
        <>
        <a href="https:\\natural-seducer.web.app"><h1 id="Title">Natural Seducer</h1></a>
        <nav class="navbar " role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                
            </div>
        </nav>
        <Wave/>
        </>

        
    );

}

export default Header;